import * as React from 'react';

const Message = () => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="shared-trip"
        transform="translate(-288.000000, -543.000000)"
        fill="#FFFFFF"
        fillRule="nonzero">
        <g id="Avatars" transform="translate(32.000000, 336.000000)">
          <g id="search-copy-6" transform="translate(0.000000, 194.000000)">
            <path
              d="M256,25.8592374 C256,18.712481 262.304322,13 270,13 C277.695678,13 284,18.712481 284,25.8592374 C284,33.0059939 277.695678,38.7184749 270,38.7184749 C269.201496,38.7184749 268.408947,38.6569441 267.628802,38.5347191 C267.32564,38.737641 266.891557,39.0287287 266.376301,39.3746506 C265.989167,39.6345578 265.578693,39.9102954 265.168373,40.1860372 C264.730734,40.4801732 264.730734,40.4801732 264.616542,40.5569352 C262.880464,41.71413 260.555024,40.4697975 260.555024,38.3834892 C260.555024,38.2656631 260.555024,38.2656631 260.555151,37.7949022 C260.55531,37.3535327 260.555596,36.9121514 260.556042,36.5001169 C260.556536,36.0432522 260.55717,35.6593823 260.55799,35.3579877 C257.672389,32.9396488 256,29.5143893 256,25.8592374 Z"
              id="Combined-Shape-Copy"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Message;



// WEBPACK FOOTER //
// ./src/assets/images/icons/message.js